import api from '@/lib/lib';

const defaultPath = '/api/v1';

export function getUser(id) {
  return api.get(`${defaultPath}/users/${id}`);
}

export function backInfo() {
  return api.get(`${defaultPath}/build`);
}
